import { render, staticRenderFns } from "./sfc-forgot-password-modal.vue?vue&type=template&id=6f21be6c&scoped=true&lang=pug&"
import script from "./sfc-forgot-password-modal.vue?vue&type=script&lang=js&"
export * from "./sfc-forgot-password-modal.vue?vue&type=script&lang=js&"
import style0 from "./sfc-forgot-password-modal.vue?vue&type=style&index=0&id=6f21be6c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f21be6c",
  null
  
)

export default component.exports